(function() {
	const appearElementList = document.querySelectorAll("[data-appear]");
	window.addEventListener("scroll", () => debounce(appearCheck));

	let debounceT = 0;
	let debounceThreshold = 100;

	appearCheck();

	function debounce(callback) {
		let t = +(new Date);
		let dt = t - debounceT;
		if(dt <= debounceThreshold) {
			return;
		}

		debounceT = t;
		callback();
	}

	function appearCheck() {
		for(const [i, el] of appearElementList.entries()) {
			const elementTop = el.getBoundingClientRect().top;

			if(elementTop <= (window.innerHeight || document.documentElement.clientHeight)) {
				el.classList.add("appeared");
			}
			else {
				el.classList.remove("appeared");
			}
		}
	}
})();
